var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-loading-button',{attrs:{"href":_vm.url,"loading":_vm.isLoading,"button-class":"green button-green create-new-button"},on:{"click":_vm.createNewCampaign}},[_vm._v("\n\tCreate New Campaign\n")])}
var staticRenderFns = []

export { render, staticRenderFns }